import { OPEN_PAYMENTS } from '@/utils/store/getterTypes'

export default {
  [OPEN_PAYMENTS] (state) {
    return state.openPayments
  }
}
